<template>
  <div class="list-item-container d-flex flex-column">
    <div class="search media">
      <div class="media-body">
        <search-input @search="searchHome"></search-input>
      </div>
    </div>
    <div class="home-list">
      <div class="create-category">
        <div>+ เพิ่มหมวดหมู่</div>
        <div>
          <el-input
            type="text"
            v-model="categoryName"
            placeholder="ตั้งชื่อหมวดหมู่ที่ต้องการ"
          ></el-input>
        </div>
        <label class="select-input">
          <span>มีผลกับแอพฯ</span>
          <input type="radio" value="true" v-model="isAffectApp" disabled/>
          <span class="checkmark radio"></span>
        </label>
        <label class="select-input">
          <span>ไม่มีผลกับแอพฯ</span>
          <input type="radio" value="false" v-model="isAffectApp"/>
          <span class="checkmark radio"></span>
        </label>
        <div class="submit-category">
          <sc-button size="sm" variant="warning" @click="handleSaveCategory"
            >บันทึก</sc-button
          >
        </div>
      </div>
      <div>
        <div class="group-category d-flex px-3 py-3">กลุ่มมีผลกับแอปฯ</div>
        <router-link
          :to="item.route"
          active-class="active"
          tag="div"
          v-for="item in listAffectApp"
          :key="item.id"
          class="home-item d-flex px-3 py-3"
        >
          <div class="flex-grow-1 flex-shrink-0">
            <h5 class="home-number">{{ item.name }}</h5>
          </div>
        </router-link>
      </div>
      <div>
        <div class="group-category d-flex px-3 py-3">กลุ่มไม่มีผลกับแอปฯ</div>
        <router-link
          :to="item.route"
          active-class="active"
          tag="div"
          v-for="item in listNotAffectApp"
          :key="item.id"
          class="home-item d-flex px-3 py-3"
        >
          <div class="flex-grow-1 flex-shrink-0">
            <h5 class="home-number">{{ item.name }}</h5>
          </div>
        </router-link>
      </div>
      <div>
        <div class="group-category d-flex px-3 py-3">กลุ่มที่ถูกยกเลิก</div>
        <router-link
          :to="item.route"
          active-class="active"
          tag="div"
          v-for="item in listCancelNotAffectApp"
          :key="item.id"
          class="home-item d-flex px-3 py-3"
        >
          <div class="flex-grow-1 flex-shrink-0">
            <h5 class="home-number">{{ item.name }}</h5>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import SearchInput from "@/components/helper/SearchInput";
import { isEmpty } from "ramda";
import ScButton from "@/lib/components/ScButton";
import { Input } from "element-ui";

export default {
  components: {
    SearchInput,
    "el-input": Input,
    ScButton,
  },
  props: ["value", "deletedAt"],
  data() {
    return {
      searchKeyword: "",
      categoryName: null,
      isAffectApp: "false",
    };
  },
  computed: {
    listAffectApp() {
      const listAffectApp = this.value.filter(
        (item) => item.isAffectApp === true
      );

      const list = !isEmpty(this.searchKeyword)
        ? listAffectApp.filter((item) =>
            item.name.toLowerCase().includes(this.searchKeyword.toLowerCase())
          )
        : listAffectApp;

      return list;
    },
    listNotAffectApp() {
      const listNotAffectApp = this.value.filter(
        (item) => (item.isAffectApp === false) & !item.deletedAt
      );

      const list = !isEmpty(this.searchKeyword)
        ? listNotAffectApp.filter((item) =>
            item.name.toLowerCase().includes(this.searchKeyword.toLowerCase())
          )
        : listNotAffectApp;

      return list;
    },
    listCancelNotAffectApp() {
      return this.value.filter((item) => item.deletedAt);
    },
  },
  methods: {
    handleSelecthome(id) {
      this.$emit("selectedHome", id);
    },
    searchHome(keyword) {
      this.searchKeyword = keyword;
    },
    handleSaveCategory() {
      if (!this.categoryName) {
        alert("กรุณาใส่ชื่อหมวดหมู่");
        return;
      }

      const newCategory = {
        category_name: this.categoryName,
        is_affect_app: this.isAffectApp,
        deleted_at: this.deletedAt,
      };

      this.$emit("createCategory", newCategory);
      this.categoryName = null;
      this.isAffectApp = "false";
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  border-bottom: 1px solid #e0e0e0;
  padding: 15px;
}
.list-item-container {
  background: white;
  border-right: solid 1px #e0e0e0;
  padding: 0;
}
.home-list {
  overflow: auto;
}

.home-item {
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
  overflow-x: auto;

  &:hover {
    background: #f9f9f9;
  }
  &.active {
    background: #efefef;
  }
  .home-number-label {
    font-size: 11px;
    color: #8c8786;
  }
  h5.home-number {
    color: black;
    font-size: 18px;
    font-weight: bold;
  }
  .member-status {
    border-radius: 5px;
    background-color: #f9f9f9;
    padding: 8px;
    .label {
      font-size: 11px;
    }
    .info {
      font-weight: bold;
      font-size: 14px;
      color: #8c8786;
    }
    &.active {
      .info {
        color: #00b793;
      }
    }
  }
}

.member-summary {
  border-top: 1px solid #e0e0e0;
  span {
    color: #8c8786;
    font-size: 11px;
  }
}
.status-statistic {
  border-right: solid 1px #d8d6d9;
  h6 {
    font-size: 22px;
    font-weight: bold;
    &.active {
      color: #00b793;
    }
  }
}
.categories {
  .info {
    text-align: right;
  }
  .count {
    color: black;
    font-weight: bold;
  }
}

.group-category {
  background-color: #6e747a;
  color: rgb(243, 241, 241);
  font-size: 16px;
  font-weight: bold;
  overflow-x: auto;
}

.create-category {
  padding-left: 13px;
  padding-right: 13px;
  padding-top: 5px;
  padding-bottom: 80px;
}

.select-input {
  margin-top: 8px;
  font-size: 14px;
  font-weight: bold;
}

.submit-category {
  padding-top: 20px;
  text-align: right;
  right: 13px;
}
</style>



// WEBPACK FOOTER //
// src/features/group/components/ListItem.vue